module.exports = __webpack_public_path__ + "assets/images/48aefadd7e1e3bcc08ee5a8a384d76ca.avif";